import { Link } from '@tanstack/react-router';
import colors from 'style-utils/colors';
import createExtractCssFromProps from 'style-utils/createExtractCssFromProps';
import styled, { css } from 'styled-components';

export const NavbarLink = styled(Link)`
  color: var(--sidebar-link-text);
  text-decoration: none;
  overflow: hidden;
  font-weight: 700;
  font-family: var(--secondary-font-family), sans-serif;

  &.selected {
    color: var(--sidebar-link-selected-text);
    background: var(--sidebar-link-selected-bg);
  }
`;

export const withAnchorStyle = css`
  color: ${colors.blackTwelve};
  font-weight: bold;
  display: inline-flex;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  -webkit-appereance: none;
  flex-flow: row nowrap;
  align-items: center;
  text-decoration: underline;
  line-height: 1.25;
  ${createExtractCssFromProps({
    textSize: 'font-size',
    innerTextSpacing: 'letter-spacing',
    whiteSpace: 'white-space',
  })}
`;

export const SimpleAnchor = styled.a`
  ${withAnchorStyle};
`;

export const InternalLink = styled(
  ({ innerTextSpacing, textSize, whiteSpace, ...rest }) => <Link {...rest} />,
)`
  ${withAnchorStyle};
`;

InternalLink.defaultProps = {
  textSize: '14px',
  innerTextSpacing: '0.32px',
};
